const MainSearch = class extends HTMLElement {
  constructor() {
    super();

    // Clicking close button
    this.querySelectorAll('.main-search__close').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
      });
    });

    // Pressing escape key
    this.querySelector('.main-search__input').addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') {
        this.querySelector('.main-search__close').dispatchEvent(new Event('click'));
      }
    });

    // Search as you type
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }
  }

  initQuickSearch() {
    const searchInput = this.querySelector('.main-search__input');
    const searchTimeoutThrottle = 500;
    const resultLimit = 12;
    const includeMeta = this.dataset.quickSearchMeta === 'true';
    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {
      const resultsBox = this.querySelector('.main-search__results');
      const valueToSearch = searchInput.value;

      // Only search if search string longer than 2, and it has changed
      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        // Save previous value
        this.oldSearchValue = valueToSearch;

        // Kill outstanding ajax request
        if (searchAbortController !== null) {
          searchAbortController.abort();
          searchAbortController = null;
        }

        // Kill previous search
        clearTimeout(searchTimeoutID);

        // Create URL for full search results
        const form = searchInput.closest('form');
        const linkURL = new URL(form.action);
        const formParams = new URLSearchParams(new FormData(form));
        formParams.forEach((value, key) => { linkURL.searchParams.set(key, value); });

        // Show loading
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
        this.classList.add('main-search--loading');
        if (!this.querySelector('.main-search__results-spinner')) {
          resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
        }

        // Do next search (in X milliseconds)
        searchTimeoutID = setTimeout(() => {
          searchAbortController = new AbortController();
          let ajaxUrl;

         // ...
         if (theme.Shopify.features.predictiveSearch) {
            // use the API
            ajaxUrl = new URL(theme.routes.base + theme.routes.predictiveSearch);
            ajaxUrl.searchParams.set('q', valueToSearch);
            ajaxUrl.searchParams.set('section_id', 'predictive-search');
            ajaxUrl.searchParams.set('resources[limit]', 25);
            // This parameter is required by your theme's JS logic:
            ajaxUrl.searchParams.set('resources[options][fields]', includeMeta ? 'title,product_type,variants.title,vendor,tag,variants.sku' : 'title,product_type,variants.title,vendor');
          } else {
            // use the theme template fallback (no change)
            ajaxUrl = new URL(linkURL);
            ajaxUrl.searchParams.set('section_id', 'main-search');
          }
// ...

          fetch(ajaxUrl, { method: 'get', signal: searchAbortController.signal })
  .then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.text();
  })
  .then((response) => {
    const template = document.createElement('template');
    template.innerHTML = response;
    let resultsList = null;
    
    if (theme.Shopify.features.predictiveSearch) {
      // Use the new search-suggestions section
      resultsList = template.content.querySelector('.search-suggestions-wrapper');
    } else {
      // Fallback to old structure
      resultsList = template.content.querySelector('.section-search-template .product-grid');
    }

    if (!resultsList) {
      throw new Error("Could not find search results container.");
    }

    // Reset previous contents
    searchAbortController = null;
    this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results', 'main-search--loading');
    resultsBox.innerHTML = '';

    // Insert the results
    resultsBox.appendChild(resultsList);

    // Check if we have results
    const productsCount = resultsList.querySelectorAll('.search-suggestion__link').length;
    
    if (productsCount > 0) {
      this.classList.add('main-search--has-results');
      if (productsCount > 6) {
        this.classList.add('main-search--results-on-multiple-lines');
      }
    } else {
      this.classList.add('main-search--no-results');
    }
  })
  .catch((error) => {
    if (error.name === 'AbortError') {
      return; // Request was aborted, ignore
    }
    console.error("Predictive Search Error:", error);
    this.classList.remove('main-search--loading', 'main-search--has-results');
    this.classList.add('main-search--no-results');
    resultsBox.innerHTML = '<div class="main-search__empty-message">Sorry, an error occurred.</div>';
  });

        }, searchTimeoutThrottle);
      } else if (!valueToSearch.length) {
        // Abandon current search
        this.oldSearchValue = valueToSearch;
        if (searchAbortController !== null) {
          searchAbortController.abort();
          searchAbortController = null;
        }
        clearTimeout(searchTimeoutID);

        // Clear results
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--loading');
        resultsBox.innerHTML = '';
      }
    };

    searchInput.addEventListener('keyup', handleInputChange.bind(this));
    searchInput.addEventListener('change', handleInputChange.bind(this));
  }
};

window.customElements.define('main-search', MainSearch);